import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Query } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import {
  Modal, AutoComplete, Radio,
} from 'antd'
import {
  Div, H3, Loading, P, Button,
} from 'konsys-ui'
import FileDownload from 'js-file-download'
import axios from 'axios'
import config from './config'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/bill-components'
import { status } from '../constants'
import { BILL_LIST, BILL_PAYMENT_LIST } from '../../../constants/graphql/query'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import './style-css.css'

const { color } = theme

const ChequeReportModal = ({
  chequeReportModal, setChequeReportModal, isLoading, setIsLoading,
}) => {
  const [selectedNumber, setSelectedNumber] = useState()
  const [isCheque, setIsCheque] = useState(true)
  const [isSelect, setIsSelect] = useState(false)
  const {
    loading, data, error, refetch,
  } = useQuery(BILL_PAYMENT_LIST, { variables: { type: isCheque ? 'CHEQUE' : 'TRANSFER' } })
  if (loading && _.isEmpty(data)) return null
  return (
    <Modal
      title="พิมพ์รายงานการชำระเงิน"
      visible={chequeReportModal}
      destroyOnClose={true}
      onCancel={() => {
        setChequeReportModal(false)
        setSelectedNumber()
        setIsSelect(false)
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/bill/chequeExcel?selectedNumber=${selectedNumber}&isCheque=${isCheque}`,
        }).then((resp) => {
          FileDownload(resp.data, `พิมพ์รายงานการชำระเงินด้วย${isCheque ? 'เช็ค' : 'การโอนเงิน'}หมายเลข ${selectedNumber}.xlsx`)
          setChequeReportModal(false)
          setSelectedNumber()
          setIsLoading(false)
          setIsSelect(false)
        })
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(selectedNumber) || !isSelect,
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='column'>
        <Radio.Group style={{ width: 'fit-content', margin: '16px 0' }} onChange={(e) => {
          setIsCheque(e.target.value)
          setSelectedNumber()
          refetch()
          setIsSelect(false)
        }} value={isCheque}>
          <Radio.Button value={true}>เช็ค</Radio.Button>
          <Radio.Button value={false}>โอนเงิน</Radio.Button>
        </Radio.Group>
        <Div width='100%' display='flex' justifyContent='space-between' alignItems='center' flexDirection='row'>
          <P margin='16px 0'>เลือก{isCheque ? 'เช็ค' : 'เลขโอนเงิน'}</P>
          <AutoComplete
            style={{ width: 334 }}
            dataSource={_.uniq(data?.BillPaymentList?.lists.map(v => v.chequeNumber || v.bankNumber).filter(word => word.length > 0))}
            onSelect={(e) => {
              setSelectedNumber(e)
              setIsSelect(true)
            }}
            onSearch={(e) => {
              setSelectedNumber(e)
              refetch(isCheque ? { chequeNumber: e } : { bankNumber: e })
            }}
          />
        </Div>
      </Div>
    </Modal>
  )
}

const Index = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [chequeReportModal, setChequeReportModal] = useState(false)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการใบปะหน้า</H3>
        <Div display='flex' flexDirection='row' justifyContent='space-between'>
          <Button
            text='พิมพ์รายงานการชำระเงิน'
            onClick={() => {
              setChequeReportModal(true)
            }}
            margin='0 16px 0 0'
          />
          {/* <DynamicButtonLink link='/bill/add' condition={_.includes(window.perms, PERMISSION.CREATE_GAS_STATION)} props={{ text: 'Create' }}/> */}
        </Div>
      </Div>
      <List/>
      <ChequeReportModal
      chequeReportModal={chequeReportModal}
      setChequeReportModal={setChequeReportModal}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      />
    </Div>
  )
}

export const List = () => {
  const [filtered, setFiltered] = useState()
  const [sorted, setSorted] = useState([{ id: 'updatedAt', desc: true }])
  const [current, setCurrent] = useState(0)
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      <Query
        query={BILL_LIST}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >{({
        data, loading, error, refetch,
      }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        return (
          <Div>
            <ReactTable
              className='table'
              data={data.BillList.lists} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              // defaultPageSize={10}
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true, refetch })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: rowInfo.original.status === status.WAITING
                        ? `3px solid ${color.warning}`
                        : rowInfo.original.status === status.OVERDUE
                          ? `3px solid ${color.error}`
                          : `3px solid ${color.success}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              noDataText='ไม่พบข้อมูล'
              page={current}
              pages={Math.ceil(data.BillList.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {}
                await newFiltered.forEach((v) => {
                  if (v.id === 'Job.Customer.companyName') Object.assign(newOjb, { companyName: v.value })
                  else Object.assign(newOjb, { [v.id]: v.value })
                })
                setFiltered(newOjb)
                setCurrent(0)
              }}
              onSortedChange={async (newSorted) => {
                setSorted(newSorted)
                setCurrent(0)
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
      </Query>

    </Wrapper>
  )
}
export default Index
